<template>
  <el-dialog
    title="赔付设置"
    :visible.sync="visible"
    width="75%"
    :before-close="handleClose"
  >
    <div
      slot="title"
      style="display: flex; justify-content: space-between; align-items: center"
    >
      <span>{{ " " }}</span>
      <span>赔付设置</span>
      <el-button size="small" style="margin-right: 30px" @click="handleLog"
        >日志</el-button
      >
    </div>

    <div v-for="(item, index) in settings" :key="index" class="setting-row">
      <el-form :model="item" :rules="rules" inline>
        <el-form-item label="商品拿货价区间">
          <el-input-number
            v-model="item.min_price"
            controls-position="right"
            placeholder="最小值"
            :min="0"
            :max="item.max_price ? item.max_price - 1 : 9999999999"
            :precision="2"
            class="price-input"
            @change="() => validateMinMax(item)"
          ></el-input-number>
          <span class="separator">-</span>
          <el-input-number
            v-model="item.max_price"
            controls-position="right"
            placeholder="最大值"
            :min="item.min_price ? item.min_price + 1 : 0"
            :precision="2"
            class="price-input"
            @change="() => validateMinMax(item)"
          ></el-input-number>
        </el-form-item>

        <el-form-item label="超期赔付计算" required>
          <el-select v-model="item.overdue_type" class="calc-type">
            <el-option label="按比例" value="1"></el-option>
            <el-option label="按绝对值" value="2"></el-option>
          </el-select>
          <div style="display: inline-flex; align-items: center">
            <el-input-number
              v-model="item.overdue_value"
              controls-position="right"
              :min="0"
              :precision="2"
              class="calc-value"
            ></el-input-number>
            <span style="margin-left: 5px">{{
              item.overdue_type === "1" ? "%" : "元"
            }}</span>
          </div>
        </el-form-item>

        <el-form-item label="断货赔付计算" required>
          <el-select v-model="item.stockout_type" class="calc-type">
            <el-option label="按比例" value="1"></el-option>
            <el-option label="按绝对值" value="2"></el-option>
          </el-select>
          <div style="display: inline-flex; align-items: center">
            <el-input-number
              v-model="item.stockout_value"
              controls-position="right"
              :min="0"
              :precision="2"
              class="calc-value"
            ></el-input-number>
            <span style="margin-left: 5px">{{
              item.stockout_type === "1" ? "%" : "元"
            }}</span>
          </div>
        </el-form-item>

        <el-button v-if="index !== 0" type="text" @click="deleteRow(index)"
          >删除</el-button
        >
      </el-form>
    </div>

    <div class="setting-footer">
      <el-button
        type="primary"
        :disabled="settings.length >= 100"
        @click="addRow"
        >+ 添加设置</el-button
      >
    </div>

    <div slot="footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleSave">保存</el-button>
    </div>

    <!-- 赔付设置日志弹窗 -->
    <el-dialog
      title="赔付设置日志"
      :visible.sync="logVisible"
      width="82%"
      append-to-body
      :modal-append-to-body="true"
    >
      <el-table :data="logs" border height="450px">
        <el-table-column
          prop="before"
          label="修改前"
          min-width="530"
          header-align="center"
          align="left"
        >
          <template #default="scope">
            <div v-html="scope.row.old_setting" />
          </template>
        </el-table-column>
        <el-table-column
          prop="after"
          label="修改后"
          min-width="530"
          header-align="center"
          align="left"
        >
          <template #default="scope">
            <div v-html="scope.row.new_setting" />
          </template>
        </el-table-column>
        <el-table-column
          prop="operator_name"
          label="操作人"
          width="80"
          align="center"
        />
        <el-table-column
          prop="create_date"
          label="操作时间"
          width="180"
          align="center"
        />
      </el-table>

      <!-- 添加分页组件 -->
      <div class="pagination" style="margin-top: 20px; text-align: right">
        <el-pagination
          :current-page="logPage"
          :page-size="logPageSize"
          :total="logTotal"
          :page-sizes="[10, 20, 50, 100]"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleLogSizeChange"
          @current-change="handleLogCurrentChange"
        />
      </div>
    </el-dialog>
  </el-dialog>
</template>

<script>
import {
  postGetCompensationSettings,
  postSetCompensationSettings,
  postGetCompensationSettingsLog,
} from "@/openapi/erp/slowCompensation.js";

export default {
  name: "CompensationSetting",

  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      settings: [
        {
          min_price: null,
          max_price: null,
          overdue_type: "1",
          overdue_value: null,
          stockout_type: "1",
          stockout_value: null,
        },
      ],
      rules: {
        overdue_value: [
          { required: true, message: "请输入超期赔付计算值" },
          { type: "number", min: 0, message: "请输入大于0的数值" },
        ],
        stockout_value: [
          { required: true, message: "请输入断货赔付计算值" },
          { type: "number", min: 0, message: "请输入大于0的数值" },
        ],
      },
      logVisible: false,
      logs: [],
      logPage: 1,
      logPageSize: 10,
      logTotal: 0,
      logLoading: false,
      originalSettings: [],
    };
  },

  watch: {
    visible: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.fetchCompensationSettings();
        }
      },
    },
  },

  methods: {
    addRow() {
      if (this.settings.length >= 100) {
        this.$message.error("最多设置100个价格区间");
        return;
      }
      this.settings.push({
        min_price: undefined,
        max_price: undefined,
        overdue_type: "1",
        overdue_value: null,
        stockout_type: "1",
        stockout_value: null,
      });
    },

    deleteRow(index) {
      this.settings.splice(index, 1);
    },

    handleClose() {
      this.$confirm("确认退出编辑?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$emit("update:visible", false);
        })
        .catch(() => {});
    },

    validateMinMax(item) {
      if (item.min_price !== null && item.max_price !== null) {
        if (Number(item.min_price) >= Number(item.max_price)) {
          this.$message.warning("最小值必须小于最大值");
          // 使用Vue的响应式更新方式，避免直接修改参数
          this.$set(item, "max_price", Number(item.min_price) + 1);
        }
      }
    },

    validateSettings() {
      // 检查必填项 - 超期/断货赔付计算值
      const hasEmptyValues = this.settings.some(
        (setting) => !setting.overdue_value || !setting.stockout_value
      );
      if (hasEmptyValues) {
        this.$message.error("所有区间均需录入超期/断货赔付计算设置");
        return false;
      }

      // 多行设置时，检查最小值和最大值关系
      for (const setting of this.settings) {
        if (
          setting.min_price !== null &&
          setting.max_price !== null &&
          Number(setting.min_price) >= Number(setting.max_price)
        ) {
          this.$message.error("商品拿货价区间最小值必须小于最大值");
          return false;
        }
      }

      // 多行设置时，检查区间交集
      for (let i = 0; i < this.settings.length; i++) {
        for (let j = i + 1; j < this.settings.length; j++) {
          const range1 = this.settings[i];
          const range2 = this.settings[j];

          const min1 = range1.min_price || 0;
          const max1 = range1.max_price === null ? Infinity : range1.max_price;
          const min2 = range2.min_price || 0;
          const max2 = range2.max_price === null ? Infinity : range2.max_price;

          if (!(max1 < min2 || max2 < min1)) {
            this.$message.error("拿货价区间之间有交集，请检查");
            return false;
          }
        }
      }
      return true;
    },

    handleSave() {
      if (!this.validateSettings()) return;

      console.warn(this.originalSettings, this.settings);

      if (
        JSON.stringify(this.originalSettings) === JSON.stringify(this.settings)
      ) {
        this.$message.info("设置数据未变化，无需保存");
        return;
      }
      // 处理空值区间
      const processedSettings = this.settings.map((item) => {
        // 如果价格区间为空，设置为空字符串而不是null或undefined
        return {
          ...item,
          min_price:
            item.min_price === undefined || item.min_price === null
              ? ""
              : item.min_price,
          max_price:
            item.max_price === undefined || item.max_price === null
              ? ""
              : item.max_price,
        };
      });

      // 对价格区间进行排序
      const sortedSettings = [...processedSettings].sort((a, b) => {
        const minA = a.min_price === "" ? 0 : Number(a.min_price);
        const minB = b.min_price === "" ? 0 : Number(b.min_price);
        return minA - minB;
      });

      this.$confirm("确认保存设置?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          console.log(sortedSettings);
          postSetCompensationSettings({ compensation_setting: sortedSettings })
            .then((res) => {
              if (res) {
                this.$message.success("保存成功");
                this.$emit("update:visible", false);
              }
            })
            .catch(() => {
              this.$message.error("保存失败");
            });
        })
        .catch(() => {});
    },

    handleLog() {
      this.logVisible = true;
      this.fetchSettingLogs();
    },

    async fetchSettingLogs() {
      this.logLoading = true;
      try {
        const params = {
          page: this.logPage,
          page_size: this.logPageSize,
        };

        const res = await postGetCompensationSettingsLog(params);
        if (res) {
          this.logs = res.list || [];
          this.logTotal = res.count || 0;
        }
      } catch (error) {
        console.error("获取设置日志失败", error);
        this.$message.error("获取设置日志失败");
      } finally {
        this.logLoading = false;
      }
    },

    handleLogSizeChange(val) {
      this.logPageSize = val;
      this.fetchSettingLogs();
    },

    handleLogCurrentChange(val) {
      this.logPage = val;
      this.fetchSettingLogs();
    },

    async fetchCompensationSettings() {
      try {
        const res = await postGetCompensationSettings();
        console.log("原始返回数据:", res);

        if (res && res.length > 0) {
          // 处理回显数据，确保空字符串正确显示为空
          this.settings = res.map((item) => {
            // 创建新对象避免直接修改原始数据
            const processedItem = { ...item };

            // 将空字符串或0转换为undefined而不是null
            // el-input-number对undefined的处理比null更好
            if (
              processedItem.min_price === "" ||
              processedItem.min_price === 0
            ) {
              processedItem.min_price = undefined;
            }

            if (
              processedItem.max_price === "" ||
              processedItem.max_price === 0
            ) {
              processedItem.max_price = undefined;
            }

            // 确保数值类型转换
            if (processedItem.min_price !== undefined) {
              processedItem.min_price = Number(processedItem.min_price);
            }

            if (processedItem.max_price !== undefined) {
              processedItem.max_price = Number(processedItem.max_price);
            }

            // 确保其他值也是正确的类型
            if (processedItem.overdue_value) {
              processedItem.overdue_value = Number(processedItem.overdue_value);
            }

            if (processedItem.stockout_value) {
              processedItem.stockout_value = Number(
                processedItem.stockout_value
              );
            }

            return processedItem;
          });

          console.log("处理后的设置数据:", this.settings);
        } else {
          this.settings = [
            {
              min_price: undefined, // 使用undefined而不是null
              max_price: undefined, // 使用undefined而不是null
              overdue_type: "1",
              overdue_value: null,
              stockout_type: "1",
              stockout_value: null,
            },
          ];
        }
        this.originalSettings = JSON.parse(JSON.stringify(this.settings));
      } catch (error) {
        this.$message.error(error.message || "获取赔付设置失败");
      }
    },
  },
};
</script>

<style scoped>
.setting-row {
  margin-bottom: 20px;
  padding: 10px;
  border-bottom: 1px solid #ebeef5;
}

.price-input {
  width: 120px;
}

.separator {
  margin: 0 10px;
}

.calc-type {
  width: 120px;
  margin-right: 10px;
}

.calc-value {
  width: 120px;
}

.setting-footer {
  margin-top: 20px;
  text-align: left;
}

.pagination {
  margin-top: 20px;
  text-align: right;
}

/* 添加日志容器样式，限制高度 */
.log-container {
  max-height: 550px;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/pages/merchantClaimsOrder/components/CompensationSetting.vue